export default __webpack_public_path__ + "static/media/productHowItWorks3.93b8708e.svg";